import {BaseNewFilter} from "uiKit"
import {KlassDropdown} from "components/Select"
import styles from "./Filter.module.css"

type Props = {
    searchValue: string
    changeSearch: any
    onApplyFilter: any
    clearFilter: any
    currentFilter: any
    onChangeFilter: any
}

const statusOptions = [
    {value: null, label: "All"},
    {value: true, label: "Active"},
    {value: false, label: "Inactive"}
]

const Filter = (props: Props) => {
    const {searchValue, changeSearch, onApplyFilter, clearFilter, currentFilter, onChangeFilter} = props

    return (
        <BaseNewFilter
            className={styles.filterContainer}
            searchValue={searchValue}
            onSearchInput={changeSearch}
            onClick={onApplyFilter}
            onClickClear={clearFilter}
            filter={currentFilter}>
            <KlassDropdown
                valueKey="value"
                labelKey="label"
                placeholder="Status"
                isClearable
                value={statusOptions.find((opt) => opt.value === currentFilter.isActive)}
                options={statusOptions}
                onChange={(newValue) => onChangeFilter("isActive", newValue?.value ?? null)}
            />
        </BaseNewFilter>
    )
}

export {Filter}
